<div class="filterOptionsRow">
  <mat-select
    [value]="sortMethod"
    (selectionChange)="onSortMethodChange.emit($event.value)"
    *hasRole="STAFF_AND_DASHBOARD_ROLES"
    [name]="sort"
  >
    <mat-option [value]="SORT_NAME">
      {{ "sort.name" | translate }}
    </mat-option>
    <mat-option [value]="SORT_LAST_ACTIVITY">
      {{ "sort.lastActivity" | translate }}
    </mat-option>
  </mat-select>

  <!-- Enabled will be displayed on the left, because of row-reverse -->
  <ng-container *ngIf="showEnabledToggle">
    <ng-container *hasRole="CAN_VIEW_DISABLED">
      <mat-slide-toggle
        [checked]="enabledOnly"
        (change)="onEnabledOnlyChange.emit($event.checked)"
      >
        {{ "customerFilter.enabledOnly" | translate }}
      </mat-slide-toggle>
    </ng-container>
  </ng-container>
</div>
